export default "__VITE_ASSET__DeU2GGXF__"